import React, { useContext } from 'react';
import { Text, Flex, Box, Tooltip } from '@chakra-ui/react';
import { ProfileContext } from '../../profile/lib/profileContext';
import ProfileThumbnail from '../../profile/component/profileThumbnail';
import { AuthContext } from '../../auth/lib/authContext';
import InsightTags from '../../insight/components/insightTags';
import SharedExperienceIcon from '../../components/icons/sharedExperienceIcon';
import { Link } from 'react-router-dom';
import useTranslation from '../../lib/i18n/useTranslation';

export default function SharedExperienceListItem({ sharedExperiences, insightsCount }) {
  const { t } = useTranslation();
  const { profile } = useContext(ProfileContext);
  const authContext = useContext(AuthContext);
  return (
    <Link to={`/shared-experiences/${sharedExperiences.id}`}>
      <Flex
        alignItems="center"
        px={3}
        py={3}
        backgroundColor="white"
        _hover={{
          background: "background.grey",
        }}
        cursor="pointer"
      >
        <Flex
          alignItems={'center'}
          width={"100%"}
          maxWidth={"350px"}
        >
          <Box width={"100%"} >
            <Text
              w={"100%"}
              fontSize={16}
              noOfLines={"1"}
            >{sharedExperiences.name}</Text>
          </Box>
        </Flex>
        <Tooltip label={t('common.owner')}>
          <Flex
            alignItems={"center"}
            gap={1}
            width={"150px"}
          >
            <ProfileThumbnail size={25}/>
            {profile.id === authContext.profile.id && 
              <Text width={"100%"} fontSize={"12px"} noOfLines={1}>{t('common.me')}</Text>
            }
            {profile.id !== authContext.profile.id && 
              <Text width={"100%"} fontSize={"12px"} noOfLines={1}>{profile.pseudo}</Text>
            }
          </Flex>
        </Tooltip>
        <Flex
          flex={1}
          justifyContent={"flex-end"}
        >
          {insightsCount && (
            <InsightTags
              nbPostiveFeedback={insightsCount.positive_count || 0}
              nbNegativeFeedback={insightsCount.negative_count || 0}
              nbImprovementFeedback={insightsCount.improvement_count || 0}
              nbBehavior={insightsCount.behavior_count || 0}
              nbMotivation={insightsCount.motivation_count || 0}
            />
          )}
        </Flex>
      </Flex>
    </Link>
  );
} 